import ClearIcon from '@mui/icons-material/Clear'
import SaveIcon from '@mui/icons-material/Save'
import { Box, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import { useState } from 'react'
import * as Yup from 'yup'

import CircularLoading from '../../../components/CircularProgress'
import UserSelectSearch from '../../../components/SelectSearch/UserSelectSearch'
import useAxios from '../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../types/pagination'
import { IUserLists } from '../../../types/user'

interface IOrderChangeStatusTelesaleFormModalProps {
  isOpen: boolean
  onClose: (visible: boolean) => void
  onSuccess: (username: string) => void
}

export interface OrderChangeStatusTelesaleForm {
  username: string
}

const getImportFormValidationSchema = () => {
  return Yup.object({
    username: Yup.string().required('กรุณาเลือกผู้ใช้'),
  })
}

export const OrderChangeStatusTelesaleFormModal = (
  props: IOrderChangeStatusTelesaleFormModalProps,
) => {
  const { isOpen, onClose, onSuccess } = props
  const [searchUserTelesales, setSearchUserTelesales] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)

  const userTelesalesList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchUserTelesales,
    },
  })
  const handleSearchUserTelesales = async (value: string) => {
    setSearchUserTelesales(value)
    await userTelesalesList.mutate()
  }

  const formik = useFormik<OrderChangeStatusTelesaleForm>({
    initialValues: {
      username: '',
    } as OrderChangeStatusTelesaleForm,
    validationSchema: getImportFormValidationSchema(),
    onSubmit: async (values: OrderChangeStatusTelesaleForm) => {
      setIsLoading(true)
      onSuccess(values.username)
      setIsLoading(false)
    },
  })

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} maxWidth="lg">
      <CircularLoading isLoading={isLoading} />
      <DialogTitle>ย้าย Telesale</DialogTitle>
      <DialogContent>
        <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={12}>
              {/* <SelectSearch<IUserLists>
                label={'กำหนดผู้ดูแล Telesale'}
                onSelect={(e) =>
                  formik.setFieldValue('username', e?.value.username)
                }
                search={searchUserTelesales}
                onSearch={handleSearchUserTelesales}
                options={
                  userTelesalesList.data?.records
                    .filter(
                      (userTelesales: IUserLists) => userTelesales.isAvailable,
                    )
                    .map((userTelesales: IUserLists) => ({
                      label: `${userTelesales.username} (${userTelesales.name})`,
                      value: userTelesales,
                    })) || ([] as IOptionSelect<IUserLists>[])
                }
              /> */}

              <UserSelectSearch
                label={'กำหนดผู้ดูแล Telesale'}
                onSelect={(e) =>
                  formik.setFieldValue('username', e?.value.username)
                }
                name="username"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
            <Grid item>
              <Button
                startIcon={<SaveIcon />}
                color="primary"
                type="submit"
                size="large"
                variant="contained"
              >
                ย้าย Telesale
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="inherit"
                size="large"
                variant="contained"
                onClick={() => onClose(false)}
                startIcon={<ClearIcon />}
              >
                ปิดหน้าต่าง
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
